/**
 * NovelMello 阅读器页面级配置
 * 翻页(chapter)与滚动(chapter-scroll)两种模式共用
 *
 * 设计 token 来源:plans/8/新站NovelMello/00-overview.md
 * pink #F0509B / purple #7C4DE8 / pink-soft #FDEFF6 / purple-soft #F3EDFE
 * ink-1 #2B1B34 / ink-2 #71607E / ink-3 #AB9BB8 / 阅读器底 #FFFCFA / 正文 #4A3D52
 */

/**
 * 阅读器皮肤色板(5 档,顺序即面板展示顺序)
 * 只作用于 novelmello 品牌;通用 THEME_BACKGROUNDS 常量保持原样不动。
 * 每个色值都必须在 chapter-theme.scss 的 .brand-novelmello 作用域内有同名 .color-XXXXXX 定义。
 */
export const NOVELMELLO_READER_BACKGROUNDS = [
  '#FFFCFA', // 默认白(设计默认态)
  '#F6EFD9', // 米黄
  '#FDE8F1', // 粉(NovelMello 新增)
  '#E3ECFA', // 浅蓝
  '#2B2430', // 夜间
] as const

/** 默认皮肤(与 payment config 的 themeDefaults.background 保持一致) */
export const NOVELMELLO_READER_DEFAULT_BACKGROUND = NOVELMELLO_READER_BACKGROUNDS[0]

/** 面板文案(ChapterTexts 未定义 Color 行 label,放页面级配置,不改公共类型、不新增 i18n key) */
export const NOVELMELLO_READER_TEXTS = {
  colorLabel: 'Color',
}

/**
 * 阅读排版参数(正文/标题字体族与行高)
 * 由 useChapterTheme 的品牌映射显式取用;其它品牌走各自的默认排版常量,输出字符串逐字符不变。
 * defaultSize:首次进入时的字号档位(存储值为 2 倍值,30 → 正文 15px、标题 15+6=21px)
 * 注意:defaultSize 优先级高于 payment 配置里的 chapter.themeDefaults.size,
 * NovelMello 的阅读排版参数统一在本文件维护(底色仍取 themeDefaults.background)。
 */
export const NOVELMELLO_READER_TYPOGRAPHY = {
  fontFamily: '"Lora", Georgia, "Times New Roman", Times, serif', // Lora 未就绪时自动降级 Georgia serif
  titleSizeDelta: 6, // 21 - 15
  titleFontWeight: 700,
  titleLineHeight: 1.3,
  contentLineHeight: 1.75,
  defaultSize: '30',
}

/** 面板设计 token(与 .novelmello.vue 的 scoped 样式保持同源,改色只改这里 + 样式常量) */
export const NOVELMELLO_READER_PANEL = {
  cardBg: '#FFFFFF',
  cardRadius: 24,
  cardShadow: '0 -8px 28px rgba(124, 77, 232, 0.12)',
  cardPadding: 20,
  pink: '#F0509B',
  purple: '#7C4DE8',
  pinkSoft: '#FDEFF6',
  purpleSoft: '#F3EDFE',
  ink1: '#2B1B34',
  ink2: '#71607E',
  ink3: '#AB9BB8',
  dotBorder: '#E5DCE8',
}
